<template>
  <vs-row vs-justify="center" id="business-box">
    <vs-col type="flex" vs-lg="12" vs-xs="12">
      <vs-card id="form">
        <vs-tabs :value="activeTab">
          <vs-tab
            :label="$t('Company.Tabs.BasicInformation')"
            icon="info"
            id="information-tab"
          >
            <vs-row class="mt-4">
              <vs-col vs-lg="4" vs-xs="12" vs-sm="6" align="center">
                <img :src="business.photo" width="250" class="" alt="user" />
                <vs-input
                  type="file"
                  class="w-75 mt-4"
                  id="fileInput"
                  :label="$t('Company.Logo')"
                  v-model="photo"
                />
              </vs-col>
              <vs-col vs-lg="8" vs-xs="12" vs-sm="6">
                <vs-row>
                  <vs-col vs-w="6">
                    <vs-input
                      :danger="errors.name"
                      :danger-text="
                        $t('Errors.InvalidPolite', {
                          field: $t('Company.Name'),
                        })
                      "
                      :label="$t('Company.Name')"
                      placeholder="12n"
                      v-model="business.name"
                      class="w-100 mb-2"
                    />
                  </vs-col>

                  <vs-col vs-w="6">
                    <vs-input
                      :label="$t('Company.Email')"
                      placeholder="12n"
                      v-model="business.email"
                      class="w-100 mb-2"
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-w="8">
                    <vs-input
                      :danger="errors.address"
                      :danger-text="
                        $t('Errors.InvalidPolite', {
                          field: $t('Company.Address'),
                        })
                      "
                      :label="$t('Company.Address')"
                      placeholder="1, Building name, Street Name"
                      v-model="business.address"
                      class="w-100 mb-2 mt-2"
                    />
                  </vs-col>
                  <vs-col vs-w="4">
                    <vs-input
                      :danger="errors.postal_code"
                      :danger-text="
                        $t('Errors.InvalidPolite', {
                          field: $t('Company.PostalCode'),
                        })
                      "
                      :label="$t('Company.PostalCode')"
                      placeholder="12345"
                      v-model="business.postal_code"
                      class="w-100 mb-2 mt-2"
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-w="6">
                    <vs-select
                      :danger="errors.country"
                      :danger-text="
                        $t('Errors.Required', { field: $t('Company.Country') })
                      "
                      class="w-100 mb-2 mt-2"
                      size="large"
                      :placeholder="$t('Company.Country')"
                      :label="$t('Company.Country')"
                      v-model="business.country"
                    >
                      <vs-select-item
                        :key="index"
                        :value="index"
                        :text="index"
                        v-for="(item, index) in countries"
                      />
                    </vs-select>
                  </vs-col>
                  <vs-col vs-w="6">
                    <vs-select
                      :danger-text="
                        $t('Errors.Required', { field: $t('Company.City') })
                      "
                      class="w-100 mb-2 mt-2"
                      size="large"
                      :placeholder="$t('Company.City')"
                      :label="$t('Company.City')"
                      v-model="business.city"
                    >
                      <vs-select-item
                        :key="index"
                        :value="item"
                        :text="item"
                        v-for="(item, index) in cities"
                      />
                    </vs-select>
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-w="6">
                    <vs-input
                      :danger="errors.phone"
                      :danger-text="
                        $t('Errors.InvalidPolite', {
                          field: $t('Company.PhoneNumber'),
                        })
                      "
                      :label="$t('Company.PhoneNumber')"
                      :placeholder="$t('Company.PhoneNumber')"
                      v-model="business.phone"
                      class="w-100 mt-2"
                    />
                  </vs-col>

                  <vs-col vs-w="6">
                    <vs-input
                      maxlength="11"
                      :label="$t('Company.SmsSenderName')"
                      placeholder="Liberrex"
                      v-model="business.sms_sender_name"
                      class="w-100 mb-2 mt-2"
                    />
                  </vs-col>
                </vs-row>

                <vs-divider></vs-divider>
                <vs-row>
                  <vs-col vs-w="6">
                    <vs-select
                      :danger-text="
                        $t('Errors.Required', { field: $t('Company.Industry') })
                      "
                      class="w-100 mb-2"
                      size="large"
                      @change="getsubindustries()"
                      :placeholder="$t('Company.Industry')"
                      :label="$t('Company.Industry')"
                      v-model="business.industry_id"
                    >
                      <vs-select-item
                        :key="index"
                        :value="item.value"
                        :text="item.text"
                        v-for="(item, index) in industries"
                      />
                    </vs-select>
                  </vs-col>
                  <vs-col vs-w="6">
                    <vs-select
                      :danger="errors.subindustry"
                      :danger-text="
                        $t('Errors.Required', {
                          field: $t('Company.SubIndustry'),
                        })
                      "
                      class="w-100 mb-2"
                      size="large"
                      :placeholder="$t('Company.SubIndustry')"
                      :label="$t('Company.SubIndustry')"
                      v-model="business.subindustry"
                    >
                      <vs-select-item :value="'0'" :text="''" />
                      <vs-select-item
                        :key="index"
                        :value="item.id"
                        :text="item.title"
                        v-for="(item, index) in subindustries"
                      />
                    </vs-select>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-w="6">
                    <vs-select
                      :danger-text="
                        $t('Errors.Required', {
                          field: $t('Company.Organization'),
                        })
                      "
                      class="w-100 mb-2"
                      size="large"
                      :placeholder="$t('Company.Organization')"
                      :label="$t('Company.Organization')"
                      v-model="business.organization_id"
                    >
                      <vs-select-item :value="''" :text="'---'" />
                      <vs-select-item
                        :key="index"
                        :value="item.value"
                        :text="item.text"
                        v-for="(item, index) in organizations"
                      />
                    </vs-select>
                  </vs-col>
                  <vs-col vs-w="6">
                    <vs-input
                      :label="$t('Company.ShortCode')"
                      v-model="business.shortcode"
                      class="w-100 mb-2"
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-w="6">
                    <vs-select
                      :danger-text="
                        $t('Errors.Required', { field: $t('Company.Industry') })
                      "
                      class="w-100 mb-2"
                      size="large"
                      :placeholder="$t('Harif.Label')"
                      :label="$t('Harif.Label')"
                      v-model="business.harif_id"
                    >
                      <vs-select-item :value="''" :text="'---'" />
                      <vs-select-item
                        :key="index"
                        :value="item.value"
                        :text="item.text"
                        v-for="(item, index) in harif_gateways"
                      />
                    </vs-select>
                  </vs-col>
                  <vs-col vs-w="6">
                    <vs-input
                      :label="$t('Company.ussd')"
                      v-model="business.ussd_short_name"
                      class="w-100 mb-2"
                    />
                   
                  </vs-col>
                </vs-row>
                <vs-row >
                    <vs-col vs-w="12">
                    <vs-checkbox
                      class="justify-content-start w-100 mb-2 mt-3"
                      v-model="business.booking_approval_check_services_status"
                    >{{$t('Company.BookingConfirmation')}}
                    </vs-checkbox>
                  </vs-col>
                  </vs-row>
              </vs-col>
            </vs-row>

            <div class="btn-alignment float-right mt-4">
              <vs-button color="primary" @click="validateFields">{{
                $t("Company.UpdateButton")
              }}</vs-button>
            </div>
          </vs-tab>
          <!-- 
          <vs-tab
            :label="$t('Company.Tabs.Permissions')"
            icon="lock"
            id="permissions-tab"
          >
            <vs-card class="mt-2">
              <h4>{{ $t("Company.BookingPermissions") }}:</h4>
              <vs-row class="mt-4" style="align-items: center">
                <vs-col vs-w="6">
                  <vs-checkbox
                    class="justify-content-start"
                    color="primary"
                    v-model="permissions.booking_allowed"
                  >
                    <b class="ml-2">{{ $t("Permissions.booking_allowed") }}</b>
                  </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-checkbox
                    class="justify-content-start"
                    color="primary"
                    v-model="permissions.booking_require_approval"
                  >
                    <b class="ml-2">{{
                      $t("Permissions.booking_require_approval")
                    }}</b>
                  </vs-checkbox>
                </vs-col>
              </vs-row>

              <vs-row class="mt-4" style="align-items: center">
                <vs-col vs-w="6">
                  <vs-checkbox
                    class="justify-content-start"
                    color="primary"
                    v-model="permissions.booking_select_date"
                  >
                    <b class="ml-2">{{
                      $t("Permissions.booking_select_date")
                    }}</b>
                  </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-checkbox
                    class="justify-content-start"
                    color="primary"
                    v-model="permissions.booking_select_slot"
                  >
                    <b class="ml-2">{{
                      $t("Permissions.booking_select_slot")
                    }}</b>
                  </vs-checkbox>
                </vs-col>
              </vs-row>

              <vs-row class="mt-4" style="align-items: center">
                <vs-col vs-w="6">
                  <vs-checkbox
                    class="justify-content-start"
                    color="primary"
                    v-model="permissions.booking_select_department"
                  >
                    <b class="ml-2">{{
                      $t("Permissions.booking_select_department")
                    }}</b>
                  </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-checkbox
                    class="justify-content-start"
                    color="primary"
                    v-model="permissions.booking_allow_attachments"
                  >
                    <b class="ml-2">{{
                      $t("Permissions.booking_allow_attachments")
                    }}</b>
                  </vs-checkbox>
                </vs-col>
              </vs-row>

              <vs-row class="mt-4" style="align-items: center">
                <vs-col vs-w="6">
                  <vs-checkbox
                    class="justify-content-start"
                    color="primary"
                    v-model="permissions.booking_require_attachments"
                  >
                    <b class="ml-2">{{
                      $t("Permissions.booking_require_attachments")
                    }}</b>
                  </vs-checkbox>
                </vs-col>
              </vs-row>

              <br />
              <hr />
              <h4>{{ $t("Company.QueuePermissions") }}:</h4>

              <vs-row class="mt-4" style="align-items: center">
                <vs-col vs-w="6">
                  <vs-checkbox
                    class="justify-content-start"
                    color="primary"
                    v-model="permissions.queue_allowed"
                  >
                    <b class="ml-2">{{ $t("Permissions.queue_allowed") }}</b>
                  </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-checkbox
                    class="justify-content-start"
                    color="primary"
                    v-model="permissions.queue_require_approval"
                  >
                    <b class="ml-2">{{
                      $t("Permissions.queue_require_approval")
                    }}</b>
                  </vs-checkbox>
                </vs-col>
              </vs-row>

              <vs-row class="mt-4" style="align-items: center;">
                <vs-col vs-w="6">
                  <vs-checkbox class="justify-content-start" color="primary" v-model="permissions.queue_only_booked" >
                    <b class="ml-2">{{$t('Permissions.queue_only_booked')}}</b>
                  </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-checkbox class="justify-content-start" color="primary" v-model="permissions.queue_require_payment" >
                    <b class="ml-2">{{$t('Permissions.queue_require_payment')}}</b>
                  </vs-checkbox>
                </vs-col>
              </vs-row> -->
          <!-- <br />
              <hr />
              <h4>{{ $t("Company.FeedbackPermissions") }}:</h4>

              <vs-row class="mt-4" style="align-items: center">
                <vs-col vs-w="6">
                  <vs-checkbox
                    class="justify-content-start"
                    color="primary"
                    v-model="permissions.anonymous_feedback"
                  >
                    <b class="ml-2">{{
                      $t("Permissions.anonymous_feedback")
                    }}</b>
                  </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-checkbox
                    class="justify-content-start"
                    color="primary"
                    v-model="permissions.feedback_view"
                  >
                    <b class="ml-2">{{ $t("Permissions.feedback_view") }}</b>
                  </vs-checkbox>
                </vs-col>
              </vs-row>
              <br />
              <hr />
              <h4>{{ $t("Company.KioskAndDisplayPermissions") }}:</h4>

              <vs-row class="mt-4" style="align-items: center">
                <vs-col vs-w="6">
                  <vs-checkbox
                    class="justify-content-start"
                    color="primary"
                    v-model="permissions.allow_kiosks"
                  >
                    <b class="ml-2">{{ $t("Permissions.allow_kiosks") }}</b>
                  </vs-checkbox>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-checkbox
                    class="justify-content-start"
                    color="primary"
                    v-model="permissions.allow_display"
                  >
                    <b class="ml-2">{{ $t("Permissions.allow_display") }}</b>
                  </vs-checkbox>
                </vs-col>
              </vs-row>

              <vs-row class="mt-4" style="align-items: center"> </vs-row>
            </vs-card>
            <div class="btn-alignment mt-4">
              <vs-button color="primary" v-on:click="updatePermission()">{{
                $t("Company.UpdateButton")
              }}</vs-button>
            </div>
          </vs-tab> -->
          <!-- 
          <vs-tab
            :label="$t('Company.Tabs.WorkingDays')"
            icon="calendar_today"
            id="working-days-tab"
          >
            <WorkingDay
              :key="index"
              v-for="(day, index) in business.working_days"
              :day="day"
            ></WorkingDay>
            <div class="btn-alignment mt-4">
              <vs-button color="primary" @click="createBusiness">{{
                $t("Company.UpdateButton")
              }}</vs-button>
            </div>
          </vs-tab>
          <vs-tab
            :label="$t('Company.Tabs.Location')"
            icon="map"
            id="location-tab"
          >
            <GmapMap
              :center="currentLocation"
              :zoom="16"
              map-type-id="terrain"
              style="width: 100%; height: 400px"
              :options="{
                zoomControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUi: false,
              }"
            >
              <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                :draggable="true"
                @click="center = m.position"
                @dragend="updateCoordinates"
              />
            </GmapMap>
            <div class="btn-alignment mt-4">
              <vs-button color="primary" @click="createBusiness">{{
                $t("Company.UpdateButton")
              }}</vs-button>
            </div>
          </vs-tab>
          <vs-tab
            :label="$t('Company.Tabs.Translation')"
            icon="translate"
            id="translation-tab"
          >
            <h4>Business Name:</h4>

            <vs-row>
              <vs-col vs-w="6" v-for="(item, index) in languages" :key="index">
                <vs-input
                  :placeholder="item"
                  :label="$t('Languages.' + item)"
                  v-model="business_translations[item]"
                  class="w-100 mt-2 mb-2"
                ></vs-input>
              </vs-col>
            </vs-row>

            <div class="btn-alignment mt-4">
              <vs-button color="primary" @click="createBusiness">{{
                $t("Company.UpdateButton")
              }}</vs-button>
            </div>
          </vs-tab> -->
          <vs-checkbox v-model="verified">Verified </vs-checkbox> <br />
        </vs-tabs>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  helpersService,
  businessService,
  industryServices,
  harifService,
} from "../../_services";
import { gmapApi } from "vue2-google-maps";
import WorkingDay from "../../components/settings/WorkingDay";
import router from "../../_helpers/router";
export default {
  name: "Business",
  data: () => ({
    verified: false,
    sumError: 0,
    title: "Business",
    activeTab: 0,
    business: {},
    photo: "",
    currentLocation: { lat: 0, lng: 0 },
    markers: [],
    errors: {
      name: false,
      address: false,
      postal_code: false,
      city: false,
      phone: false,
      industry: false,
      subIndustry: false,
    },
    countries: [],
    cities: [],
    industries: [],
    organizations: [],
    harif_gateways: [],
    subindustries: [],
    steps: [
      {
        target: ".vs-card--content", // We're using document.querySelector() under the hood
        params: {
          placement: "auto", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#information-tab", // We're using document.querySelector() under the hood
        params: {
          placement: "top-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#working-days-tab", // We're using document.querySelector() under the hood
        params: {
          placement: "top-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#location-tab", // We're using document.querySelector() under the hood
        params: {
          placement: "top-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
    ],
    languages: [],
    business_translations: {
      ar: "",
      fr: "",
      en: "",
      de: "",
      es: "",
      ru: "",
      pt: "",
    },
    permissions: {
      booking_allowed: false,
      booking_require_approval: false,
      booking_select_date: false,
      booking_select_slot: false,
      booking_select_department: false,
      booking_allow_attachments: false,
      booking_require_attachments: false,
      queue_allowed: false,
      queue_require_approval: false,
      queue_only_booked: false,
      queue_require_payment: false,
      anonymous_feedback: false,
      feedback_view: false,
      allow_kiosks: false,
      allow_display: false,
    },
  }),
  methods: {
    ...mapActions("account", ["updateUserObject"]),
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    validateFields() {
      (this.errors.name = this.business.name ? false : true),
        (this.errors.address = this.business.address ? false : true),
        (this.errors.postal_code = this.business.postal_code ? false : true),
        (this.errors.city = this.business.city ? false : true),
        (this.errors.phone = this.business.phone ? false : true),
        (this.errors.industry = this.business.industry ? false : true),
        (this.errors.subIndustry = this.business.subIndustry ? false : true);

      let {
        name,
        email,
        address,
        postal_code,
        city,
        phone,
        industry,
        subIndustry,
      } = this.errors;
      console.log(this.errors);
      if (
        this.errors.name == false &&
        this.errors.address == false &&
        //  this.errors.email == false &&
        this.errors.postal_code == false &&
        // this.errors.city == false &&
        this.errors.phone == false
        //this.errors.industry == false
      ) {
        this.createBusiness();
        console.log("famch errors");
      } else {
        console.log("fama errors");
      }
    },
    showLoading() {
      this.$vs.loading({
        container: "#business-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#business-box > .con-vs-loading");
    },
    createBusiness() {
      // this.showLoading();
      // this.validateFields();

      let business = new FormData();
      business.append("name", this.business.name);
      business.append("email", this.business.email);
      business.append("address", this.business.address);
      business.append("postal_code", this.business.postal_code);
      business.append("country", this.business.country);
      business.append("city", this.business.city);
      business.append("phone", this.business.phone);
      business.append("industry", this.business.industry_id);
      business.append("verified", this.verified);
      business.append("approved", 1);

      business.append("subindustry", this.business.subindustry);
      business.append(
        "working_days",
        JSON.stringify(this.business.working_days)
      );
      business.append("lat", "36");
      business.append("lng", "10");
      business.append("translations", this.business.translations);

      if (
        this.business.shortcode != "null" &&
        this.business.shortcode != null &&
        this.business.shortcode != ""
      ) {
        business.append("shortcode", this.business.shortcode);
      } else {
        business.append("shortcode", "");
      }

      if (
        this.business.sms_sender_name != "null" &&
        this.business.sms_sender_name != null &&
        this.business.sms_sender_name != ""
      ) {
        business.append("sms_sender_name", this.business.sms_sender_name);
      } else {
        business.append("sms_sender_name", "");
      }

      if (
        this.business.organization_id != "null" &&
        this.business.organization_id != null &&
        this.business.organization_id != ""
      ) {
        business.append("organization_id", this.business.organization_id);
      } else {
        business.append("organization_id", "");
      }

      if (this.business.subindustry == null) {
        this.business.subindustry = "";
        business.append("subindustry", this.business.subindustry);
      }

      business.append("harif_id", this.business.harif_id);
      business.append("ussd_short_name", this.business.ussd_short_name);
      business.append("booking_approval_check_services_status", this.business.booking_approval_check_services_status ? 1 : 0);
      business.append("_method", "POST");

      if (
        document.getElementById("fileInput") &&
        document.getElementById("fileInput").files[0]
      ) {
        business.append("photo", document.getElementById("fileInput").files[0]);
      }
      businessService
        .createBusiness(business)
        .then(
          function (data) {
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Company.EditBasic.ToastSuccess"),
              "success"
            );
            let userOld = JSON.parse(localStorage.getItem("user"));
            userOld.business = data.business;
            localStorage.setItem("user", JSON.stringify(userOld));
            this.updateUserObject();
          }.bind(this)
        )
        .catch(
          function () {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Company.EditBasic.ToastFail"),
              "danger"
            );
          }.bind(this)
        )
        .finally(
          function () {
            businessService
              .getById(this.$route.params.id)
              .then((data) => {
                this.business = data.business;
              })
              .finally(() => {
                this.hideLoading();
              });
          }.bind(this)
        );
      // console.log(this.business.working_days);
    },
    updatePermission() {
      const self = this;
      this.showLoading();
      let permissions = new FormData();
      permissions.append("id", this.permissions.id);
      permissions.append("business_id", this.permissions.business_id);
      permissions.append("booking_allowed", this.permissions.booking_allowed);
      permissions.append(
        "booking_require_approval",
        this.permissions.booking_require_approval
      );
      permissions.append(
        "booking_select_date",
        this.permissions.booking_select_date
      );
      permissions.append(
        "booking_select_slot",
        this.permissions.booking_select_slot
      );
      permissions.append(
        "booking_select_department",
        this.permissions.booking_select_department
      );
      permissions.append(
        "booking_allow_attachments",
        this.permissions.booking_allow_attachments
      );
      permissions.append(
        "booking_require_attachments",
        this.permissions.booking_require_attachments
      );
      permissions.append("queue_allowed", this.permissions.queue_allowed);
      permissions.append(
        "queue_only_booked",
        this.permissions.queue_only_booked
      );
      permissions.append(
        "queue_require_approval",
        this.permissions.queue_require_approval
      );
      permissions.append(
        "queue_require_payment",
        this.permissions.queue_require_payment
      );
      permissions.append(
        "anonymous_feedback",
        this.permissions.anonymous_feedback
      );
      permissions.append("feedback_view", this.permissions.feedback_view);
      permissions.append("allow_kiosks", this.permissions.allow_kiosks);
      permissions.append("allow_display", this.permissions.allow_display);

      permissions.append("_method", "POST");

      businessService
        .updatePermissions(permissions)
        .then(function (data) {
          this.permissions = data.settings;
          self.notify(
            self.$t("Toasts.Successful"),
            self.$t("Company.EditBasic.ToastSuccess"),
            "success"
          );
          self.hideLoading();
        })
        .catch(function () {
          self.notify(
            self.$t("Toasts.Successful"),
            self.$t("Company.EditBasic.ToastSuccess"),
            "success"
          );
          self.hideLoading();
        });
    },
    updateCoordinates(location) {
      this.markers[0].position = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },
    goToNextTab(currentStep) {
      this.$tours["SettingsBusiness"].nextStep();
      if (currentStep == 1) {
        this.activeTab = 1;
      } else if (currentStep == 2) {
        this.activeTab = 2;
      }
    },
    goToNextPage() {
      router.push({ path: "/settings/team?istour=on" });
    },
    getsubindustries() {
      let data2 = { industry_id: this.business.industry_id };
      industryServices.getsubindustries(data2).then(
        function (data) {
          if (this.business.industry != data2.industry_id) {
            this.business.subindustry = 0;
          }
          this.subindustries = data.subindustries;
        }.bind(this)
      );
    },
  },
  computed: {
    ...mapState({
      account_info: (state) => state.account.user.user,
      business_info: (state) => state.account.user.business,
      workingDays: (state) => state.account.user.working_days,
    }),
    google: gmapApi,
  },

  mounted() {
    businessService.getById(this.$route.params.id).then(
      function (data) {
        this.business = data.business;
        console.log(data.business);

        this.permissions = data.business.myLiberrex;

        console.log("(data.permissions");
        console.log(this.permissions);
        let data2 = { industry_id: this.business.industry_id };
        industryServices.getsubindustries(data2).then(
          function (data) {
            this.subindustries = data.subindustries;

            data.subindustries.forEach((obj) => {
              this.subindustries.push({
                value: obj.id,
                text: obj.title,
              });
              if (obj.id == this.business.subindustry) {
                this.business.subindustry = obj.id;
              }
              // alert(this.business.subindustry)
            });
          }.bind(this)
        );
        let location = {
          lat: parseFloat(this.business.lat),
          lng: parseFloat(this.business.lng),
        };
        this.markers.push({ position: location });
        this.currentLocation = location;
      }.bind(this)
    );
    this.languages = this.$i18n.availableLocales;

    helpersService.getIndustries().then(
      function (data) {
        this.industries = [];
        data.industries.forEach((obj) => {
          this.industries.push({
            value: obj.id,
            text: obj.name,
          });
          if (obj.id == this.business.industry_id) {
            this.business.industry = obj.id;
          }
        });
      }.bind(this)
    );

    helpersService.getOrganizations().then(
      function (data) {
        console.log("________________");
        console.log(data);
        this.organizations = [];
        data.organizations.data.forEach((obj) => {
          this.organizations.push({
            value: obj.id,
            text: obj.name,
          });
          if (obj.id == this.business.organization_id) {
            this.business.organization_id = obj.id;
          }
        });
      }.bind(this)
    );

    harifService.getAll().then(
      function (data) {
        this.harif_gateways = [];
        data.harif_gateways.forEach((obj) => {
          this.harif_gateways.push({
            value: obj.harif_id,
            text: obj.name,
          });
          if (obj.harif_id == this.business.harif_id) {
            this.business.harif_id = obj.harif_id;
          }
        });
      }.bind(this)
    );

    if (this.business.organization_id == null) {
      this.business.organization_id = "";
    }
    if (this.business.sms_sender_name == null) {
      this.business.sms_sender_name = "";
    }
    helpersService.getCountries().then(
      function (data) {
        this.countries = data.countries;
        this.cities = this.countries[this.business.country];
      }.bind(this)
    );

    // businessService.getTranslations().then(function (data) {
    //   if(data.translations.translations != null){
    //     this.business_translations = data.translations.translations;
    //   }
    // }.bind(this));

    this.$t("Company.Content").map(
      (content, index) => (this.steps[index].content = content)
    );
    this.$route.query.istour && localStorage.getItem("skipTour") != "true"
      ? this.$tours["SettingsBusiness"].start()
      : "";
  },
  components: {
    WorkingDay,
  },
};
</script>
